import { createClient } from '@supabase/supabase-js'
import { CONFIG_APP_SUPABASE_CLIENT, CONFIG_APP_SUPABASE_TOKEN } from './configApp'

const supabase = createClient(CONFIG_APP_SUPABASE_CLIENT, CONFIG_APP_SUPABASE_TOKEN)

export {
  supabase
}